import React from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { backendApi } from "@/api/backendApi";
import CandidateCard from "../components/candidates/CandidateCard";

export default function CandidateDetail() {
  const [params] = useSearchParams();
  const id = params.get("id");

  const { data: candidate } = useQuery({
    queryKey: ["candidate", id],
    queryFn: () => backendApi.db.Candidate.findOne({ id }),
  });

  if (!candidate) return <p>Loading...</p>;

  return (
    <div className="max-w-3xl space-y-8">
      <CandidateCard candidate={candidate} />

      <div>
        <h2 className="font-semibold text-lg text-slate-900 mb-3">About</h2>
        <p className="text-slate-600 whitespace-pre-line">{candidate.notes || "No notes added"}</p>
      </div>

      {candidate.resume_url && (
        <a
          href={candidate.resume_url}
          className="text-indigo-600 underline"
          target="_blank"
          rel="noreferrer"
        >
          View Resume
        </a>
      )}
    </div>
  );
}
